import BackgroundVideo from '../../../resources/scripts/helpers/background-video';

class BrixHero {
  static init(...parameters) {
    return new BrixHero(...parameters);
  }

  constructor(block) {
    if (block) {
      const backgroundVideoWrapper = document.querySelector(`#${block.id} > .background > .video`);

      if (backgroundVideoWrapper) {
        BackgroundVideo.init(block);
      }
    }
    this.revealOnScroll(block);
  }

  revealOnScroll(block) {
    const animations = ['slide-in-bottom', 'slide-in-left', 'slide-in-right', 'slide-in-top', 'fade-in'];
    const content = block.getElementsByClassName('content')[0];
    const children = content.childNodes;
    const triggerOffset = window.innerWidth > 800 ? 0.5 : 0.3;
    // eslint-disable-next-line no-restricted-syntax
    for (const name of animations) {
      if (block.classList.contains(name)) {
        children.forEach((child) => {
          if (child.classList) {
            // eslint-disable-next-line no-param-reassign
            child.classList.add('hidden');
          }
        });
      }
    }

    const handleAnimation = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const contentChildren = entry.target.childNodes;

          // eslint-disable-next-line no-restricted-syntax
          for (const name of animations) {
            if (block.classList.contains(name)) {
              contentChildren.forEach((child, i) => {
                setTimeout(() => {
                  if (child.classList) {
                    child.classList.add(`${name}-animation`);
                    child.classList.remove('hidden');
                  }
                }, 50 * i);
              });
            }
          }
          observer.unobserve(entry.target);
        }
      });
    };

    const observer = new IntersectionObserver(handleAnimation, { threshold: triggerOffset });
    observer.observe(content);
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-hero', BrixHero.init);
}
